import { Component, ViewChild } from '@angular/core';
import { GenericAttachmentUploadProperties } from './generic-attachment-upload-properties';
import { HttpClient } from '@angular/common/http';
import { WrapperStandardRequest, WrapperStandardResponse } from '../../common/models/wrapper.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { result } from 'lodash';
import { GlobalProperties } from 'src/app/global/global-properties';

@Component({
    template: ''
})
export class GenericAttachmentUploadFunctions<T> extends GenericAttachmentUploadProperties<T>{
    private selectedFile: FileList = null!;
    private ArrayofSelectedFile = new Array<string>();
    private selectedAttacment: any = [];

    constructor(private http: HttpClient) {
        super();
       
    }
    protected onSelectedFilesFunction(event: any) {
        this.ArrayofSelectedFile = [];
        if (event.target.files) {
            this.selectedFile = <FileList>event.target.files;
            this.setAttactmentList = this.selectedFile;
            this.ArrayofSelectedFile.push(event.target.files);
        }
        console.log(this.selectedAttacment);
    }

    protected onUploadFileFunction(attachmentEntry: any) {
        const filedata = new FormData();
        this.selectedFile = this.getSelectedFileList.target.files;
        for (let i = 0; i < this.selectedFile.length; i++) {
            filedata.append('image', this.selectedFile[i], this.selectedFile[i].name);
            //   console.log(this.selectedFile[0].name);
            // console.log(Math.floor(this.selectedFile[0].size / 1024));
        }
        if (attachmentEntry != null && attachmentEntry != "" && attachmentEntry != undefined) {
            this.http.patch(`${GlobalProperties.getApiUrlSap}Attachments2(${attachmentEntry})`, filedata, { withCredentials: true }).
                subscribe(res => {
                    console.log(res)
                    this.setAbsEntry = res;

                })
        }
        else {
            this.http.post(`${GlobalProperties.getApiUrlSap}Attachments2`, filedata, { withCredentials: true }).
                subscribe(res => {
                    console.log(res)
                    this.setAbsEntry = res;
                    localStorage.removeItem('Absolute');
                    localStorage.setItem("Absolute", this.getAbsEntry.AbsoluteEntry);

                })
        }
    }

    protected onAttachmentDeleteFileFunction(attachmentEntry: any, Attachments2_Lines: string[]) {
        var _attach = new Attachment();
        _attach.Attachments2_Lines = Attachments2_Lines;
        this.http.put(`${GlobalProperties.getApiUrlSap}Attachments2(${attachmentEntry})`, _attach, { withCredentials: true }).
            subscribe(res => {
                console.log("deleted item");
            })
    }
    async onAttachmentGetFileFunction(attachmentEntry: string): Promise<Array<T>> {
        //  let attachments2_Lines: any = [];
        let result: any;
        if (attachmentEntry != null && attachmentEntry != undefined) {
            let aUrl = `${GlobalProperties.getApiUrlSap}Attachments2(${attachmentEntry})`;
            result = this.GetAPIWithWrapperReturnsT(aUrl);
            result.then((result: any) => {
                this.setAttactmentListData = result.Attachments2_Lines;
            })
            return await result;
        }
        else {
            this.setAttactmentListData = [];
        }
        return await result;

    };

    GetAPIWithWrapperReturnsT(aUrl: string): any {

        const wrapperStandardRequest: WrapperStandardRequest<any> = new WrapperStandardRequest<any>();
        let promise = new Promise((resolve, reject) => {
            this.GetAPI(aUrl).subscribe(async (wrapperStandardResponse: WrapperStandardResponse<T>) => {
                resolve(await wrapperStandardResponse)
            })
        });
        return promise;
    }

    GetAPI(aUrl: string): Observable<any> {
        return this.http.get(aUrl, { withCredentials: true })
            .pipe(map((response: any) => {
                return response;
            }))
    }


}
class Attachment {
    Attachments2_Lines: any[] = []
}